import { defineMessages } from 'react-intl';

const messages = defineMessages({
  noTeamMemberTitle: {
    id: 'team.noTeamMember.title',
    defaultMessage: 'No team member',
    description: 'No team member as title',
  },
  noTeamMemberDescription: {
    id: 'team.noTeamMember.description',
    defaultMessage: 'Your team member is not set yet. Please select a team member.',
    description: 'No team member description',
  },
  noTeamMemberCta: {
    id: 'team.noTeamMember.cta',
    defaultMessage: 'Add team member',
    description: 'Add team member button',
  },
});

export default messages;
